// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"804":"app-oficina","966":"app-chofer"}[chunkId] || chunkId) + "." + {"239":"5c4b3bbb","261":"266fba06","395":"f02d4f54","455":"d2a825c6","804":"e4ca0e4e","939":"807a590a","966":"d0b807eb","977":"e30e0df5"}[chunkId] + ".chunk.js";
};